<template>
  <img :src="src || DEFAULT_AVATAR_URL" :alt="name" class="avatar" v-bind="$attrs" />
  <!-- <span
        v-if="!src && name"
        :style="{ 
            'font-size': getFontSize,
        }"
        class="avatar"
        v-bind="$attrs"
    >
        <span>{{ /^[a-zA-Z]*$/.test(getName) ? getName : getName.slice(0, 1) }}</span>
    </span>  -->
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { DEFAULT_AVATAR_URL } from '@/constants'

const props = defineProps({
  src: String,
  name: String,
  fontSize: String
})

const getName = computed(() => (props.name?.length && props.name?.length > 0 ? props.name[0] : ''))

const getFontSize = computed(() =>
  props?.fontSize ? props.fontSize : /^[a-zA-Z]*$/.test(getName.value) ? '40px' : '26px'
)
</script>

<style lang="less" scoped>
.avatar {
  display: inline-flex;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 1px solid #e8e8e8;
  object-fit: cover;
  color: #fff;
  line-height: 1;
  // background: url('@/assets/no-avatar.png') no-repeat;
  background-size: cover;
  align-items: center;
  justify-content: center;
}
</style>
